/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useMemo, useState } from "react";
import { IconContext } from "react-icons";
import { BsFillHeartFill as Heart } from "react-icons/bs";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import "swiper/css";
import { useServiceLikeMutation } from "../../../Hooks/Mutations/ServiceMutation/useLikeMutation";
import useAuth from "../../../Hooks/useAuth";
import Login from "../../../sections/Login/Login";
import { SignUp } from "../../../sections/SignUp/SignUp";
import "./card.css";
import SecondaryHeading from "../Typography/SecondaryHeading";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import MainButton from "../MainButton/MainButton";
import Title from "../../common/Title/Title";
import SpecialText from "../Typography/SpecialText";
import Pro from "../Tags/Pro";
import Featured from "../Tags/Featured";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import SharePopup from "../SharePopup/SharePopup";

const AdsCard = ({
  sellerName,
  category,
  serviceName,
  serviceDescription,
  type,
  Images,
  rating,
  companyName,
  companyLogo,
  serviceId,
  Col,
  companyId,
  replaceLink,
  reaction,
  selfWidth,
  likes = 0,
  views = 0,
  userPlan,
  hideUserInfo = false,
  hideShare = false,
  hideHeart = false,
  hideLikes = false,
  hideViews = false,
  isFeatured = false,
  titleAlwaysVisible = false,
  onSignInChange,
  onSignUpChange,
  onSharePopup,
}) => {
  const id = useMemo(() => Math.round(Math.random() * 1000), []);
  const [heartClick, setheartClick] = useState(reaction);
  const navigate = useNavigate();
  const { auth } = useAuth();
  
  // Use external popup handlers if provided, otherwise use internal state
  const [internalSignUpState, setInternalSignUpState] = React.useState(false);
  const [internalSignIn, setInternalSignIn] = React.useState(false);
  const [internalSharePopupOpen, setInternalSharePopupOpen] = useState(false);
  
  const SignUpState = onSignUpChange ? false : internalSignUpState;
  const SignIn = onSignInChange ? false : internalSignIn;
  const sharePopupOpen = onSharePopup ? false : internalSharePopupOpen;
  
  const setSignUpState = onSignUpChange || setInternalSignUpState;
  const setSignIn = onSignInChange || setInternalSignIn;
  const sharePayload = {
    postTitle: serviceName,
    currentUrl: `${window.location.origin}/service-detail/?id=${serviceId}`,
    previewImage: Array.isArray(Images) && Images.length > 0 ? (Images[0]?.url ? { url: Images[0].url } : Images[0]) : null,
    projectTitle: serviceName,
    businessName: companyName,
    previewCompanyLogo: companyLogo,
  };
  const setSharePopupOpen = onSharePopup ? (isOpen) => onSharePopup(isOpen, sharePayload) : setInternalSharePopupOpen;

  // Memoize the image source to prevent unnecessary re-renders
  const imageSource = useMemo(() => {
    if (Array.isArray(Images) && Images.length > 1) {
      return Images;
    }
    return Images?.[0]?.url ?? Images?.[0] ?? require("../../../assets/img/default-post-image.webp");
  }, [Images]);

  useEffect(() => {
    setheartClick(reaction);
  }, [reaction]);

  const { mutate } = useServiceLikeMutation();
  const handleLike = (serviceId, reaction) => {
    if (!auth?.user) {
      if (onSignInChange) {
        onSignInChange(true);
      } else {
        setSignIn(true);
      }
    } else {
      setheartClick(!heartClick);
      mutate({
        userId: auth.user.id,
        serviceId: serviceId,
        reaction: !reaction,
      });
    }
  };

  // Handle share button click
  const handleShareClick = (e) => {
    e.stopPropagation();
    if (onSharePopup) {
      onSharePopup(true, sharePayload);
    } else {
      setSharePopupOpen(true);
    }
  };

  // Generate the share URL for this post
  const shareUrl = `${window.location.origin}/service-detail/?id=${serviceId}`;

  const location = useLocation();
  return (
    <>
      {/* Popups are now handled externally when onSignInChange, onSignUpChange, or onSharePopup props are provided */}
      {!onSignInChange && SignIn && (
        <Login
          location={location.pathname + location.search}
          SignIn={SignIn}
          setSignIn={setSignIn}
          SignUpState={SignUpState}
          setSignUpState={setSignUpState}
        />
      )}
      {!onSignUpChange && SignUpState && (
        <SignUp
          location={location.pathname + location.search}
          SignUpState={SignUpState}
          setSignUpState={setSignUpState}
          SignIn={SignIn}
          setSignIn={setSignIn}
        />
      )}
      <div className="relative aspect-[413/309.75]">
        <div className="group/main cursor-pointer relative overflow-hidden">
          {/* Share and Save (Heart) circle icons in overlay - title shows on hover unless titleAlwaysVisible */}
          <div
            className={`div1 absolute z-10 top-1/4 px-3 w-full h-full ${titleAlwaysVisible ? 'block' : 'hidden group-hover/main:block'}`}
            onClick={() => {
              navigate({
                pathname: "/service-detail/",
                search: `?${createSearchParams({ id: serviceId })}`,
              });
            }}
          >
            <div className="flex flex-col justify-between -mt-[15%] h-[88%]">
              <div className="flex flex-col">
                {/* Share circle icon */}
                {!hideShare && (
                  <Title text={"Share this post"} width={"111"}>
                    <button
                      type="button"
                      className="icon-circle bg-white relative group"
                      onClick={handleShareClick}
                    >
                      <i className="fi fi-rs-share text-offblack cursor-pointer duration-500 transition-all group-hover:text-mediumgray" />
                    </button>
                  </Title>
                )}
                {/* Save/Heart circle icon */}
                {!hideHeart && (
                  <Title text={"Save this post"} width={"100"}>
                    <button
                      type="button"
                      className="icon-circle bg-white relative mt-2 group"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLike(serviceId, reaction);
                      }}
                    >
                      <i
                        className={`fi fi-rs-heart cursor-pointer duration-500 transition-all group-hover:text-alertred ${
                          heartClick === true ? "text-alertred" : "text-offblack"
                        }`}
                      />
                    </button>
                  </Title>
                )}
              </div>
              <div className="text-white w-full">
                <div
                  className={`flex gap-x-2 cursor-pointer ${Array.isArray(imageSource) && imageSource.length > 1 ? 'mb-4' : ''}`}
                  onClick={() => {
                    navigate(
                      {
                        pathname: "/poster-profile/",
                        search: `?${createSearchParams({
                          id: companyId,
                          name: companyName,
                        })}`,
                      },
                      { replace: replaceLink }
                    );
                  }}
                >
                  <div className="flex flex-col">
                    <SecondaryHeading
                      variant={"MainParagraphHeading"}
                      className={
                        "w-full overflow-hidden text-ellipsis break-words !font-normal"
                      }
                    >
                      {serviceName}
                    </SecondaryHeading>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {Array.isArray(imageSource) && imageSource.length > 1 && (
            <div className={`custom-pagination-${id} absolute bottom-0 w-full flex items-center justify-center gap-0 py-2 [&_.swiper-pagination-bullet]:w-2 [&_.swiper-pagination-bullet]:h-2 [&_.swiper-pagination-bullet]:rounded-full [&_.swiper-pagination-bullet]:bg-white [&_.swiper-pagination-bullet]:opacity-50 [&_.swiper-pagination-bullet-active]:!opacity-100 [&_.swiper-pagination-bullet]:!mx-1 [&_.swiper-pagination-bullet]:transition-all [&_.swiper-pagination-bullet]:duration-300 [&_.swiper-pagination-bullet]:hover:scale-110 [&_.swiper-pagination-bullet]:cursor-pointer [&_.swiper-pagination-bullet]:shadow-[0_2px_4px_rgba(0,0,0,0.2)] z-[19]`}></div>
          )}
          <div className="relative w-full aspect-[413/309.75]">
            {Array.isArray(imageSource) && imageSource.length > 1 ? (
              <Swiper
                modules={[Pagination]}
                pagination={{
                  clickable: true,
                  bulletClass: 'swiper-pagination-bullet',
                  bulletActiveClass: 'swiper-pagination-bullet-active',
                  el: `.custom-pagination-${id}`,
                }}
                className="w-full h-full rounded-xl"
              >
                {imageSource.map((image, index) => (
                  <SwiperSlide key={index} className="!w-full">
                    <div className="relative w-full h-full">
                      <div className={`absolute inset-0 bg-gradient-to-t from-black/80 to-transparent transition-opacity duration-300 h-4/1 bottom-0 z-[2] rounded-xl ${titleAlwaysVisible ? 'opacity-50' : 'opacity-0 group-hover/main:opacity-50'}`}></div>
                      <img
                        onClick={() => {
                          navigate({
                            pathname: "/service-detail/",
                            search: `?${createSearchParams({
                              id: serviceId,
                            })}`,
                          });
                        }}
                        className="cursor-pointer rounded-xl object-cover w-full h-full"
                        src={image.url || image}
                        alt={`product image ${index + 1}`}
                        onError={(e) => {
                          e.target.src = require("../../../assets/img/default-image.jpg");
                        }}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div className="relative w-full h-full">
                <div className={`absolute inset-0 bg-gradient-to-t from-black/80 to-transparent transition-opacity duration-300 h-4/1 bottom-0 z-[2] rounded-xl ${titleAlwaysVisible ? 'opacity-50' : 'opacity-0 group-hover/main:opacity-50'}`}></div>
                <img
                  onClick={() => {
                    navigate({
                      pathname: "/service-detail/",
                      search: `?${createSearchParams({
                        id: serviceId,
                      })}`,
                    });
                  }}
                  className="cursor-pointer rounded-xl object-cover w-full h-full"
                  src={imageSource}
                  alt="product images"
                  onError={(e) => {
                    e.target.src = require("../../../assets/img/default-image.jpg");
                  }}
                />
              </div>
            )}
            {/* Featured and Pro tags overlay */}
            <div className="absolute top-4 right-2 z-10 flex flex-col gap-1">
              {isFeatured && <Featured />}
            </div>
          </div>
        </div>
        {!hideUserInfo && (
        <div className="relative text-offblack">
            <div className="flex items-center justify-between w-full mt-3 h-[24px]">
              <div className="flex gap-x-2 items-center">
                {!hideUserInfo && (
                  <div className="group/profile relative">
                    <Link to={`/poster-profile/?id=${companyId}`}>
                    <img
                      className="avatar-extra-small object-cover object-center cursor-pointer"
                      src={
                        !companyLogo || companyLogo === "null"
                          ? require("../../../assets/img/default-image.jpg")
                          : companyLogo
                      }
                      alt={"no-image"}
                      onError={(e) => {
                        e.target.src = require("../../../assets/img/default-image.jpg");
                      }}
                    />
                    </Link>
                    {/* Hover card */}
                    {/* <div className="hidden lg:group-hover/profile:block absolute z-20"> */}
                    <div className="hidden absolute z-20">

                      <div
                        className={`bg-white -ml-2 -mt-[240px] w-[350px] sm:w-[400px] h-[200px] rounded-xl p-5`}
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex items-center">
                            <div className="relative">
                            <Link to={`/poster-profile/?id=${companyId}`}>
                              <img
                                className="avatar-small object-cover object-center cursor-pointer"
                                // src={require("../../../assets/img/User.png")}
                                src={
                                  !companyLogo || companyLogo === "null"
                                    ? require("../../../assets/img/User.png")
                                    : companyLogo
                                }
                                alt={"no-image"}
                              />
                              </Link>
                              {userPlan === 'pro' && (
                                <div className="absolute -mt-3 left-[30%]">
                                  <div className="mt-[1px] mr-3">
                                    <Pro className={"bg-offblack text-white"} />
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="ml-3">
                              <div>
                                <SpecialText variant={"ProfileSecondary"}>
                                  {companyName}
                                </SpecialText>
                              </div>
                              <div>
                                <SpecialText variant="ProfileMeta">
                                  {/* {category} */}
                                </SpecialText>
                              </div>
                            </div>
                          </div>
                          <div>
                            <MainButton variant={"outlinesmall"}>
                              Follow
                            </MainButton>
                          </div>
                        </div>
                        <div className="flex items-center justify-between mt-5">
                          <div className="w-[100px] sm:w-[109px] h-[82px]">
                            <img
                              src={require("../../../assets/img/default-image.jpg")}
                              className="w-full h-full rounded-xl object-center"
                              alt="portfolio"
                            />
                          </div>
                          <div className="w-[100px] sm:w-[109px] h-[82px]">
                            <img
                              src={require("../../../assets/img/default-image.jpg")}
                              className="w-full h-full rounded-xl object-center"
                              alt="portfolio"
                            />
                          </div>
                          <div className="w-[100px] sm:w-[109px] h-[82px]">
                            <img
                              src={require("../../../assets/img/default-image.jpg")}
                              className="w-full h-full rounded-xl object-center"
                              alt="portfolio"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="w-0 h-0 border-l-[10px] border-l-transparent border-t-[15px] border-t-white border-r-[10px] border-r-transparent ml-1"></div>
                    </div>
                  </div>
                )}
                {!hideUserInfo && (
                  <div className="flex items-center gap-x-2">
                    <SpecialText
                      className={"overflow-hidden text-ellipsis text-offblack"}
                      variant={"ProfileSecondary"}
                      onClick={() => {
                        navigate({
                          pathname: "/service-detail/",
                          search: `?${createSearchParams({
                            id: serviceId,
                          })}`,
                        });
                      }}
                    >
                      {companyName}
                    </SpecialText>
                    {userPlan === "pro" && (
                      <Link to={"/pro"} className="shrink-0">
                        <Pro className="bg-mediumgray text-white duration-500 transition-all hover:bg-offblack" />
                      </Link>
                    )}
                  </div>
                )}
              </div>
              <div className="flex items-center gap-x-2">
                {/* Heart/Like icon and count */}
                {!hideHeart && !hideLikes && (
                  <div className="flex items-center">
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLike(serviceId, reaction);
                      }}
                      className="flex items-center justify-center"
                    >
                      <IconContext.Provider
                        value={{
                          className: `size-4 sm:size-4 cursor-pointer duration-500 trasition-all flex items-center justify-center ${
                            heartClick === true
                              ? "text-alertred"
                              : "text-mediumgray hover:text-alertred"
                          } `,
                        }}
                      >
                        <Heart />
                      </IconContext.Provider>
                    </div>
                    <SpecialText
                      variant={"Counter"}
                      className={"ml-1 text-offblack"}
                    >
                      {likes}
                    </SpecialText>
                  </div>
                )}
                {/* View/Eye icon and count */}
                {!hideViews && (
                  <div className="flex items-center">
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLike(serviceId, reaction);
                      }}
                      className="flex items-center justify-center"
                    >
                      <i className="fi fi-ss-eye text-sm sm:text-base text-mediumgray duration-500 trasition-all hover:text-offblack flex items-center justify-center"></i>
                    </div>
                    <div>
                      <SpecialText
                        variant={"Counter"}
                        className={"ml-1 text-offblack"}
                      >
                        {views}
                      </SpecialText>
                    </div>
                  </div>
                )}
              </div>
            </div>
        </div>
              )}
        </div>
        {!onSharePopup && sharePopupOpen && (
          <SharePopup
            isOpen={sharePopupOpen}
            onClose={() => setSharePopupOpen(false)}
            postTitle={serviceName}
            currentUrl={shareUrl}
            variant="project"
            previewImage={
              Array.isArray(Images) && Images.length > 0
                ? (Images[0]?.url ? { original: Images[0].url } : Images[0])
                : Array.isArray(imageSource)
                  ? (imageSource[0]?.url ? { original: imageSource[0].url } : imageSource[0])
                  : imageSource
            }
            projectTitle={serviceName}
            businessName={companyName}
            previewCompanyLogo={companyLogo}
          />
        )}
      </>
    );
};

export default AdsCard;
